import React from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import Required from '../../Required';
import FileInput from '../../UI/upload/FileInput';


export default function NewAttachmentItem({
  info, onDelete, onChange, attachments, isValid
}) {
  function onChangeField(value, field) {
    const attachmentsCopy = [...attachments];
    attachmentsCopy[info.number] = { ...attachments[info.number], [field]: value };
    onChange([...attachmentsCopy], 'attachments');
  }

  return (
    <Card className="mb-3">
      <Card.Header className="py-3 px-4 d-flex align-center justify-content-between">
        <Card.Title className="m-0">Приложение {info.number + 1}</Card.Title>
        <Button onClick={() => onDelete(info.number)} variant="light" className="btn-close" size="md" />
      </Card.Header>
      <Card.Body className="p-4">
        <Form.Group className="mb-2">
          <Form.Label>
            Название файла
            {' '}
            <Required className="ml-2" />
          </Form.Label>
          <br />
          <Form.Control
            type="text"
            required
            value={attachments.find((v, i) => i === info.number).fileName}
            onChange={(e) => onChangeField(e.target.value, 'fileName')}
          />
          <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Файл
            {' '}
            <Required className="ml-2" />
          </Form.Label>
          <br />
          <FileInput
            isSingle
            onFileChange={(files) => onChangeField(files[0], 'file')}
            format="pdf"
          />
          {!isValid && !info.file && <p style={styledAlert}>Обязательное поле к заполнению</p>}
        </Form.Group>
      </Card.Body>
    </Card>
  );
}

const styledAlert = { fontSize: '14px', lineHeight: '20px', color: '#dc3545' }
